import * as React from 'react';
import * as _ from 'lodash';
import { connect, ConnectedProps } from 'react-redux';
import { confirmAlert } from '../../../../../services/mini/alanConfirmAlert';
import * as userActions from '../../../../../redux/user/actions.user';
import * as gitHubIntegrationActions from '../../../../../redux/gitHubIntegration/actions.gitHubIntegration';
import * as unloadPageActions from '../../../../../redux/unloadPage/actions.unloadPage';
import showOauthDialog from '../../../../../services/mini/showOauthDialog';
import asyncDispatch from '../../../../../services/mini/asyncDispatch';
import CommitScriptChangesToGitHubForm from '../CommitScriptChangesToGitHubForm/CommitScriptChangesToGitHubForm';
import ToasterService from '../../../../../services/ToasterService';
import messages from '../../../../../const/messages';
import { SHOW_ADD_GITHUB_REPO_URL_POPUP } from '../../../../../redux/gitHubIntegration/actionTypes.gitHubIntegration';
import FolderIcon from '../../../../icons/FolderIcon';
import { getRepoInfo } from '../../../../../services/mini/gitHelpers';
import ConfirmPopup from '../../../../components/ConfirmPopup/ConfirmPopup';
import ChangesToPullForm from '../ChangesToPullForm/ChangesToPullForm';
import device from '../../../../../services/mini/device';
import errorMessages from '../../../../../const/errorMessages';
import { Environment } from '../../../../../const/environment';
import * as moment from 'moment';
import { IProject } from '../../../../../models/IProject';
import { ITag } from '../../../../../models/ITag';
import { IRemoveGitHubProjectSettingsParam } from '../../../../../redux/gitHubIntegration/actions.gitHubIntegration';

const { default: githubLogo } = require("../../../../../assets/images/github/github-white.svg");

const ONE_MIN = 60000;
const FIVE_MIN = ONE_MIN * 1;

type GitHubRepoPanelProps = PropsFromRedux & {
    projectId: string
    environment: Environment
    project: IProject
    className?: string
}

class GitHubRepoPanel extends React.Component<GitHubRepoPanelProps> {

    pullAndPushBtnsInterval: number;

    componentDidMount() {
        const {
            projectId,
            getGitHubProjectSettings,
            gitUserProject,
            environment
        } = this.props;

        getGitHubProjectSettings({ projectId, environment }).then(() => {
            if (gitUserProject && !this.pullAndPushBtnsInterval) {
                this.updateDataByTimer();
            }
        }).catch(() => { });
    }

    componentDidUpdate() {
        const {
            gitUserProject,
            hasGithubAccess,
            project,
            showAddGithubRepoUrlPopup,
            environment
        } = this.props;

        if (gitUserProject && hasGithubAccess && !this.pullAndPushBtnsInterval) {
            this.updateDataByTimer();
        }

        if (gitUserProject && hasGithubAccess) {
            localStorage.removeItem(SHOW_ADD_GITHUB_REPO_URL_POPUP);
        }

        if (!gitUserProject && hasGithubAccess) {
            const showUrlPopup = !!localStorage.getItem(SHOW_ADD_GITHUB_REPO_URL_POPUP);
            if (showUrlPopup) {
                localStorage.removeItem(SHOW_ADD_GITHUB_REPO_URL_POPUP);
                showAddGithubRepoUrlPopup({ project, environment });
            }
        }
    }

    componentWillUnmount() {
        this.clearPullAndPushBtnsInterval();
        this.props.resetGitHubProjectData();
    }

    updateDataByTimer = () => {
        const {
            gitUserProject,
            hasGithubAccess,
            checkChangesToPull,
            checkChangesToPush,
            getScriptsForCiCd,
            githubDeployId,
            project,
        } = this.props;

        const isCiCd = githubDeployId != null && githubDeployId !== '';

        this.pullAndPushBtnsInterval = Number(setInterval(() => {
            if (isCiCd) {
                getScriptsForCiCd({
                    project: this.props.project,
                    environment: this.props.environment
                });
            } else {
                if (gitUserProject && hasGithubAccess) {
                    checkChangesToPull({ project }).catch(this.clearPullAndPushBtnsInterval);
                    checkChangesToPush({ project }).catch(this.clearPullAndPushBtnsInterval);
                }
            }

        }, isCiCd ? FIVE_MIN : ONE_MIN));
        if (!isCiCd) {
            checkChangesToPull({ project }).catch(this.clearPullAndPushBtnsInterval);
            checkChangesToPush({ project }).catch(this.clearPullAndPushBtnsInterval);
        }
    }

    clearPullAndPushBtnsInterval = () => {
        clearInterval(this.pullAndPushBtnsInterval);
        this.pullAndPushBtnsInterval = null;
    }

    requesRepoGithubAccess = () => {
        const { updateUnloadPageListenerForProject, getGithubOauthUrl } = this.props;

        updateUnloadPageListenerForProject({ hasListener: false });
        getGithubOauthUrl({ action: 'repo', repositoryAccess: true, withUserId: true }).then((authUrl) => {
            showOauthDialog(authUrl);
        });
    }

    addRepo = () => {
        const { showAddGithubRepoUrlPopup, project, environment } = this.props;
        showAddGithubRepoUrlPopup({ project, environment });
    }

    removeRepo = () => {
        const { removeGitHubProjectSettings, project, gitUserProject } = this.props;

        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <ConfirmPopup
                        onClose={onClose}
                        okBtnLabel="Disconnect"
                        cancelBtnLabel="Cancel"
                        okBtnCb={() => {
                            this.clearPullAndPushBtnsInterval();
                            onClose();
                            removeGitHubProjectSettings({ project });
                        }}
                        title="Warning"
                        message={<div>Are you sure you want to remove a connection to the <b>{gitUserProject}</b> repository?</div>}
                    />
                );
            }
        });
    }

    pullProject = () => {
        const { project, pullProjectFromGithub, checkProjectForUnsavedChanges } = this.props;
        checkProjectForUnsavedChanges({ project, gitAction: 'pull' }).then(() => {
            pullProjectFromGithub({ project });
        });
    }

    pushProject = () => {
        const {
            project,
            pushProjectToGithub,
            checkProjectForUnsavedChanges,
            checkChangesToPush,
            checkChangesToPull
        } = this.props;

        checkProjectForUnsavedChanges({ project, gitAction: 'push' }).then(() => {
            checkChangesToPush({ project, manually: true }).then((needToPush) => {
                if (needToPush) {
                    checkChangesToPull({ project }).then((hasChangesToPull) => {
                        if (hasChangesToPull) {
                            confirmAlert({
                                customUI: ({ onClose }) => {
                                    return (
                                        <ChangesToPullForm onClose={onClose} />
                                    );
                                }
                            });
                        } else {
                            confirmAlert({
                                customUI: ({ onClose }) => {
                                    return <CommitScriptChangesToGitHubForm
                                        project={project}
                                        pushProjectToGithub={pushProjectToGithub}
                                        onClose={onClose} />;
                                }
                            });
                        }
                    });
                } else {
                    ToasterService.showInfo({ title: messages.pushToGithubIsNotNeeded });
                }
            });
        });
    }

    render() {
        const {
            repoUrl,
            gitUserProject,
            isPushing,
            isPulling,
            isRequestProcessing,
            hasChangesToPull,
            hasChangesToPush,
            hasGithubToken,
            hasGithubAccess,
            className,
            repoPermissions,
            githubScope,
            githubDeployId,
            environment,
            project
        } = this.props;

        const { path } = getRepoInfo(repoUrl);
        let canPull = true, canPush = true;

        const ciCdIntegration = githubDeployId !== '';

        if (repoPermissions) {
            canPull = repoPermissions.pull;
            canPush = repoPermissions.push;
        }

        let content;

        const currentTag = _.find(project.tags, { tagId: project[`${environment}TagId`] }) as ITag;

        if (device.isMobile()) {
            return <React.Fragment></React.Fragment>;
        }

        let btnLabel;
        const hasRepoScope = githubScope?.indexOf('repo') > -1;
        if (!repoUrl || !hasGithubAccess || !hasGithubToken) {

            if (isRequestProcessing) {
                btnLabel = 'Syncing...';
            } else {
                if (hasRepoScope && hasGithubToken) {
                    btnLabel = 'Add GitHub repo';
                } else {
                    btnLabel = (gitUserProject || hasRepoScope) ? 'Re-sync with GitHub' : 'Sync with GitHub';
                }
            }

            content = <div
                className={`github-repo-panel__sync-with-github action-btn middle width-100p ${(hasGithubAccess === null || isRequestProcessing) ? 'btn-loader' : ''}`}
                onClick={(hasRepoScope && hasGithubToken) ? this.addRepo : this.requesRepoGithubAccess}>
                <img src={githubLogo} />
                {btnLabel}
            </div>;
        } else {
            if (environment !== Environment.Staging && !githubDeployId) {
                btnLabel = 'Add GitHub repo';
                content = <div
                    className={`github-repo-panel__sync-with-github action-btn middle width-100p ${(hasGithubAccess === null || isRequestProcessing) ? 'btn-loader' : ''}`}
                    onClick={(hasRepoScope && hasGithubToken) ? this.addRepo : this.requesRepoGithubAccess}>
                    <img src={githubLogo} />
                    {btnLabel}
                </div>;
            } else {
                content = <div>
                    <div className="github-repo-panel__repo-cotrols">
                        <div className="github-repo-panel__repo-info">
                            <img src={githubLogo} />
                            <div className="github-repo-panel__repo-info-details">
                                <div className="github-repo-panel__repo-name">
                                    <a
                                        target="_blank"
                                        rel="noreferrer"
                                        href={`https://github.com/${gitUserProject}`}
                                        title={gitUserProject}>{gitUserProject}</a> <i className="icon icon-alan-remove" onClick={this.removeRepo} />
                                </div>
                                {path && <div className="github-repo-panel__repo-folder" title={path}>
                                    <FolderIcon /> {path}
                                </div>}
                            </div>
                        </div>
                        {!ciCdIntegration ?
                            <div className="github-repo-panel__repo-btns">
                                <div
                                    className={`github-repo-panel__pull-btn ${isPulling && 'btn-loader'} ${!canPull && 'disabled-with-cursor'}`}
                                    onClick={canPull ? this.pullProject : undefined}
                                    title={!canPull ? 'You cannot pull changes from the current repository' : ''}>
                                    <i className={`icon icon-alan-arrow-rounded github-repo-panel__pull-icon ${hasChangesToPull && 'active'}`} />
                                    Pull
                                </div>
                                <div
                                    className={`github-repo-panel__push-btn ${isPushing && 'btn-loader'} ${!canPush && 'disabled-with-cursor'}`}
                                    onClick={canPush ? this.pushProject : undefined}
                                    title={!canPush ? 'You cannot push changes to the current repository' : ''}>
                                    <i className={`icon icon-alan-arrow-rounded github-repo-panel__push-icon ${(hasChangesToPush && !isPulling) && 'active'}`} />
                                    Push
                                </div>
                            </div> :
                            <React.Fragment>
                                {
                                    currentTag && <div className="github-repo-panel__sync-info">
                                        Synced on {moment(+currentTag.updateTs).format('HH:mm MM/DD/YYYY')}
                                    </div>
                                }
                            </React.Fragment>}
                    </div>
                </div>;
            }
        }

        return (
            <div className={`github-repo-panel ${hasGithubAccess === null && 'disabled'} ${className}`}>
                {content}
            </div>
        );
    }
}

function mapStateToProps({ gitHubIntegration, user }) {
    return {
        gitUserProject: gitHubIntegration.gitUserProject,
        isPushing: gitHubIntegration.isPushing,
        isPulling: gitHubIntegration.isPulling,
        isRequestProcessing: gitHubIntegration.isRequestProcessing,
        hasChangesToPull: gitHubIntegration.hasChangesToPull,
        hasChangesToPush: gitHubIntegration.hasChangesToPush,
        repoUrl: gitHubIntegration.repoUrl,
        hasGithubToken: gitHubIntegration.hasGithubToken,
        hasGithubAccess: gitHubIntegration.hasGithubAccess,
        repoPermissions: gitHubIntegration.repoPermissions,
        githubScope: user.githubScope,
        githubDeployId: gitHubIntegration.githubDeployId,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getGithubOauthUrl: (param) => asyncDispatch(userActions.getGithubOauthUrl, dispatch, param),
        showAddGithubRepoUrlPopup: (param) => asyncDispatch(gitHubIntegrationActions.showAddGithubRepoUrlPopup, dispatch, param),
        getGitHubProjectSettings: (param) => asyncDispatch(gitHubIntegrationActions.getGitHubProjectSettings, dispatch, param),
        pullProjectFromGithub: (param) => asyncDispatch(gitHubIntegrationActions.pullProjectFromGithub, dispatch, param),
        pushProjectToGithub: (param) => asyncDispatch(gitHubIntegrationActions.pushProjectToGithub, dispatch, param),
        removeGitHubProjectSettings: (param: IRemoveGitHubProjectSettingsParam) => asyncDispatch(gitHubIntegrationActions.removeGitHubProjectSettings, dispatch, param),
        checkChangesToPull: (param) => asyncDispatch(gitHubIntegrationActions.checkChangesToPull, dispatch, param),
        checkChangesToPush: (param) => asyncDispatch(gitHubIntegrationActions.checkChangesToPush, dispatch, param),
        checkProjectForUnsavedChanges: (param) => asyncDispatch(gitHubIntegrationActions.checkProjectForUnsavedChanges, dispatch, param),
        resetGitHubProjectData: () => asyncDispatch(gitHubIntegrationActions.resetGitHubProjectData, dispatch),
        getScriptsForCiCd: (param) => asyncDispatch(gitHubIntegrationActions.getScriptsForCiCd, dispatch, param),
        updateUnloadPageListenerForProject: (param) => asyncDispatch(unloadPageActions.updateUnloadPageListenerForProject, dispatch, param),
    };
}


const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(GitHubRepoPanel);